import { render, staticRenderFns } from "./OdontogramaGerenciarCobrancas.vue?vue&type=template&id=433f4b0e&scoped=true"
import script from "./OdontogramaGerenciarCobrancas.vue?vue&type=script&lang=js"
export * from "./OdontogramaGerenciarCobrancas.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaGerenciarCobrancas.vue?vue&type=style&index=0&id=433f4b0e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433f4b0e",
  null
  
)

export default component.exports